<template>
  <div id="app">
    <Main />
  </div>
</template>

<script>
import Main from './components/Main'

export default {
  name: 'App',
  components: {
    Main
  }
}
</script>

<style>
body {
  margin: 0;
  background-color: #000;
}

h2 {
  margin: 0;
}

p {
  margin: 0;
  line-height: 1.6;
}

a {
  color: inherit;
}

a:hover,
a:visited {
  color: inherit;
}

#app {
  /* font-family: "Noto Sans JP", "Avenir", Helvetica, Arial, sans-serif; */
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'Yu Gothic',
    YuGothic, Verdana, Meiryo, 'M+ 1p', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-size: 13px;
  color: #ddd;
  height: 100%;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue